<template>
  <div class="hello">
    Hello World
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue